<template>
  <div class="success_sended">
    <div class="success_sended-wrapper">
      <img
        class="success_sended-img"
        :src="require(`../assets/images/done.svg`)"
        alt=""
      />
      <p class="success_sended-text">
        {{ "Ваша заявка принята! После её регистрации вы увидите заявку в списке обращений." }}
      </p>
      <div class="success_sended-back">
        <router-link
          :to="{
            name: 'Orders',
          }"
          class="success_sended-back__link"
          >К моим заказам</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Success",
  data() {
    return {
      requestNumber: 0,
    };
  },
  computed: {
    requestNum() {
      return this.$route.params.requestNumber;
    },
  },
  methods: {
    checkRequestNum() {
      if (this.requestNum) {
        this.requestNumber = this.requestNum;
      } else {
        return;
      }
    },
  },
  created() {
    this.checkRequestNum();
  },
});
</script>

<style>
.success_sended {
  height: 100vh;
  width: 100vw;
  background-color: #e9e9e9;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  overflow: hidden;
}

.success_sended-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  text-align: center;
}

.success_sended-img {
  width: 50px;
  height: 50px;
}

.success_sended-text {
  margin-top: 20px;
  font-size: 18px;
}

.success_sended-back {
  max-width: 200px;
  background-color: #2196f3;
  border-radius: 3px;
  margin-top: 40px;
  padding: 10px 23px;
  text-decoration: none;
}

.success_sended-back__link {
  text-decoration: none;
  color: #fff;
}
</style>
